const useAccessToken = () => localStorage.getItem('jwtAccessToken') || null;

export default useAccessToken;
